import { createGlobalStyle } from 'styled-components'
import { PancakeTheme } from '@pancakeswap/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme { }
}

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Inter', system-ui, sans-serif;
  }

  body {
    font-variant-numeric: tabular-nums;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2 {
    font-family: 'Space Grotesk', 'Inter', system-ui, sans-serif;
    letter-spacing: -0.02em;
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: #3A3859 transparent;
  }

  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  *::-webkit-scrollbar-thumb {
    background: #3A3859;
    border-radius: 8px;
  }

  *::-webkit-scrollbar-thumb:hover {
    background: #4C4A73;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  :focus-visible {
    outline: 2px solid rgba(139, 92, 246, 0.7);
    outline-offset: 2px;
  }

  /* text inputs have their own focus affordance (panel focus-within ring) */
  input:focus-visible,
  input:focus,
  textarea:focus-visible,
  textarea:focus {
    outline: none;
  }

  html, body, #__next {
    min-height: 100%;
    min-width: 100%;
    display: flex;
  }

  html {
    background: #0F0F23;
  }

  ::selection {
    background: #8B5CF6;
    color: #F8FAFC;
  }

  body {
    /* inset:0 rather than 100vw/100vh — 100vw includes the scrollbar (horizontal
       overflow) and 100vh is wrong under mobile browser chrome */
    &::before {
      content: '';
      position: fixed;
      inset: 0;
      z-index: -3;
      background-color: #0F0F23;
      background-image:
        radial-gradient(ellipse 55% 40% at 82% -5%, rgba(139, 92, 246, 0.18), transparent 65%),
        radial-gradient(ellipse 50% 38% at 8% 105%, rgba(109, 40, 217, 0.16), transparent 65%);
    }

    /* Brand layer, dimmed so the violet aurora leads and the magenta wash in the
       artwork stops competing with the UI accent colour. */
    &::after {
      content: '';
      position: fixed;
      inset: 0;
      z-index: -2;
      opacity: 0.4;
      background-image: url('/assets/bg2.webp');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      pointer-events: none;
    }

    img {
      height: auto;
      max-width: 100%;
    }
  }

  #__next {
    position: relative;
    z-index: 1;
  }

  #portal-root, #toast-root {
    position: relative;
    z-index: 2;
  }

  .position-type {
    background: #3F3F46;
    font-size: 0.7em;
    padding: 0 0.5em;
    border-radius: 0.5em;
  }

  .position-range {
    background: #fff3;
    color: white;
    font-size: 0.7em;
    padding: 0 0.5em;
    border-radius: 0.5em;
    margin-top: -0.4em;
    width: fit-content;
    text-transform: capitalize;
  }
`

export default GlobalStyle
